import Pagination from './pagination';
import MiniSelect from './MiniSelect';
Pagination.MiniSelect = MiniSelect
export default Pagination;
